module.exports = __webpack_public_path__ + "img/msg.f172cc6c.jpg";